function Image_form_element(element) {
    this.$element = $(element);
    this.popup = i4_Popup.get(this.$element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    buttonChoose: '.js-button-choose',
	    buttonUpload: '.js-button-upload',
	    buttonImageEditCurrent: '.js-button-image-edit-current',
	    buttonImageEditUploaded: '.js-button-image-edit-uploaded',
	    buttonImageEditChoosed: '.js-button-image-edit-choosed',
	    hiddenUploadedFile: '.js-hidden-uploaded-file',
	    imagePreviewChoose: '.js-container-preview-choose',
	    imagePreviewUpload: '.f-upload__preview',
      hiddenAddType: '.js-hidden-add-type',
      labelSelectorDiv: '.f-image__label-selector',
      labelSelectorDivNotDefined: '.f-image__label-notdefined'
    };

    this.data = {
	    pluginFilemanager: 'plugin-filemanager',
	    pluginImage: 'plugin-image',
	    targetField: 'target-field',
	    cropParameterField: 'crop-parameter-field',
	    editParameter: 'edit-parameter',
	    elementName: 'element-name',
	    url: 'url'
    };

    this.triggers = {
	    uploadComplete: 'i4:upload-complete',
	    uploadCompleteImage: 'i4:upload-complete-image',
	    chooseComplete: 'i4:choose-complete',
	    chooseCancel: 'i4:choose-cancel',
	    afterLoaded: 'i4:afterLoaded'
    };

    this.init = function() {
	    this.dataPluginFilemanager = this.$element.data(this.data.pluginFilemanager);
	    this.dataPluginImage = this.$element.data(this.data.pluginImage);
	    this.dataTargetField = this.$element.data(this.data.targetField);
	    this.dataCropParameterField = this.$element.data(this.data.cropParameterField);
	    this.dataEditParameter = this.$element.data(this.data.editParameter);
      this.dataElementName = this.$element.data(this.data.elementName);

      this.$labelSelectorDiv = this.$element.find(this.selectors.labelSelectorDiv);
      this.$labelSelectorDivNotDefined = this.$element.find(this.selectors.labelSelectorDivNotDefined);

      this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$buttonChoose = this.$element.find(this.selectors.buttonChoose);
	    this.$buttonUpload = this.$element.find(this.selectors.buttonUpload);
	    this.$buttonImageEditCurrent = this.$element.find(this.selectors.buttonImageEditCurrent);
	    this.$buttonImageEditUploaded = this.$element.find(this.selectors.buttonImageEditUploaded);
	    this.$buttonImageEditChoosed = this.$element.find(this.selectors.buttonImageEditChoosed);
	    this.$hiddenUploadedFile = this.$element.find(this.selectors.hiddenUploadedFile);
	    this.$hiddenChoosedFile = this.$element.find('#'+this.dataTargetField);
      this.$imagePreviewChoose = this.$element.find(this.selectors.imagePreviewChoose);
	    this.$imagePreviewUpload = this.$element.find(this.selectors.imagePreviewUpload);
	    this.$hiddenAddType = this.$element.find(this.selectors.hiddenAddType);

	    this.$buttonChoose.on('click', this.$onChooseClick.bind(this));
	    this.$buttonImageEditCurrent.on('click', this.$onEditCurrentClick.bind(this));
	    this.$buttonImageEditUploaded.on('click', this.$onEditUploadedClick.bind(this));
	    this.$buttonImageEditChoosed.on('click', this.$onEditChoosedClick.bind(this));

	    this.$hiddenUploadedFile.on(this.triggers.uploadComplete, this.$onUploadChange.bind(this));
	    this.$hiddenUploadedFile.on(this.triggers.uploadCompleteImage, this.$onUploadChangeImage.bind(this));
	    this.$hiddenChoosedFile.on(this.triggers.chooseComplete, this.$onChooseChange.bind(this));
	    this.$hiddenChoosedFile.on(this.triggers.chooseCancel, this.$onChooseCancel.bind(this));

      this.$formParent.on(this.triggers.afterLoaded, (function() {
        this.updateView();
      }).bind(this));
    };

    this.$onEditCurrentClick = function(event) {
	    event.preventDefault();
	    i4_Document_listener.set_click_position({top: event.pageY,  left: event.pageX});

	    this.showEditPopup();
    };

    this.$onEditUploadedClick = function(event) {
	    event.preventDefault();
	    i4_Document_listener.set_click_position({top: event.pageY,  left: event.pageX});

	    this.showEditPopup(this.$hiddenUploadedFile.val());
    };

    this.$onEditChoosedClick = function(event) {
	    event.preventDefault();
	    i4_Document_listener.set_click_position({top: event.pageY,  left: event.pageX});

	    this.showEditPopup(this.$hiddenChoosedFile.val());
    };

    this.showEditPopup = function(newFilemanagerId) {

	    i4_Popup.add()
			.set_option({
				ajax_param: {
					js: this.dataPluginImage,
					call: 'edit_image',
					crop_parameter_field: this.dataCropParameterField,
					new_fm_id: newFilemanagerId !== undefined ? newFilemanagerId : null
				},
				ajax_param_string: this.dataEditParameter,
		    	position: this.popup ? this.popup : 'cursor',
		    	loader: true
		    })
		    .add_callback('before_remove', (function() {
			    if (this.popup) {
			    	this.popup.show();
			    }
		    }).bind(this))
		    .run();

	    if (this.popup) {
        this.popup.hide();
      }
    };

    this.$onChooseClick = function(event) {
      event.preventDefault();
      i4_Document_listener.set_click_position({top: event.pageY,  left: event.pageX});

      i4_Popup.add()
        .set_option({
          ajax_param: {
            js: this.dataPluginFilemanager,
            call: 'choose_image',
            target_field: this.dataTargetField
          },
            position: this.popup ? this.popup : 'cursor',
            loader: true
          })
          .add_callback('before_remove', (function() {
            if (this.popup) {
              this.popup.show();
            }
          }).bind(this))
          .run();

      if (this.popup) {
        this.popup.hide();
      }
    };

    this.$onUploadChange = function() {
		  this.lastType = 'upload';
		  this.updateView();
    };

    this.$onUploadChangeImage = function() {
		  this.lastType = 'upload-image';
		  this.updateView();
    };

    this.$onChooseChange = function() {
      this.$imagePreviewChoose = this.$element.find(this.selectors.ImagePreviewChoose);

		  this.lastType = 'choose';
		  this.updateView();
    };

    this.$onChooseCancel = function() {
		  this.lastType = 'cancel';
		  this.updateView();
    };

    this.updateView = function() {
      this.$imagePreviewChoose = this.$element.find(this.selectors.imagePreviewChoose);
      this.$imagePreviewUpload = this.$element.find(this.selectors.imagePreviewUpload);

	    this.$buttonImageEditUploaded.hide();
	    this.$buttonImageEditChoosed.hide();

	    this.$hiddenAddType.val(this.lastType);

	    // console.log('this.lastType', this.lastType);
      // console.log('this.$imagePreviewChoose', this.$imagePreviewChoose);
      // debugger;

	    if (this.lastType === 'upload' || this.lastType === 'upload-image') {
		    this.$imagePreviewUpload.show();
        this.$imagePreviewChoose.hide();

		    this.$hiddenUploadedFile.attr('name', this.dataElementName);
        this.$hiddenChoosedFile.attr('name', 'false');
	    } else if (this.lastType === 'choose') {
        this.$imagePreviewChoose.show();
        this.$imagePreviewUpload.hide();
        this.$labelSelectorDiv.hide();

	    	this.$hiddenChoosedFile.attr('name', this.dataElementName);
		    this.$hiddenUploadedFile.attr('name', 'false');
      }

		  this.$element.trigger('i4:change');

      if (this.lastType === 'upload-image') {
        var param = jQuery.param({
          js: 'Label',
          call: 'getLabelCheckboxes'
        });

        i4_Ajax.factory().
          set_parameter(param).
          set_option({
            on_success: ((response) => {
              if (response === '') {
                this.$labelSelectorDivNotDefined.show();
              } else {
                this.$labelSelectorDiv.html(response);
                this.$labelSelectorDiv.show();
                this.attachLabelSelectionEvent();
              }

            }).bind(this)
          }).
          run();
      }
    };

    this.attachLabelSelectionEvent = function() {
      const labelCheckboxes = this.$labelSelectorDiv.find('input[type=checkbox]');
      $(labelCheckboxes).on('click', this.$onLabelSelectionClick);
    };

    this.$onLabelSelectionClick = (event) => {
      const labelId = Number(event.target.value);
      const filemanagerId = this.$hiddenUploadedFile.val();

      const checked = $(event.target).get(0).checked;
      if (checked) {
        this.addImageLabelRelation(filemanagerId, labelId);
      } else if (!checked) {
        this.deleteImageLabelRelation(filemanagerId, labelId);
      }
    };

    this.addImageLabelRelation = function (filemanagerId, labelId) {
      var param = jQuery.param({
        js: 'Label',
        call: 'add-label-relation',
        label_id: labelId,
        filemanager_id: filemanagerId,
      });

      i4_Ajax.factory().
          set_parameter(param).
          run();
    };

    this.deleteImageLabelRelation = function (filemanagerId, labelId) {
      var param = jQuery.param({
        js: 'Label',
        call: 'delete_relation',
        label_id: labelId,
        filemanager_id: filemanagerId,
      });

      i4_Ajax.factory().
          set_parameter(param).
          run();
    };
}
